// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Banner/Dismiss.story.tsx with go/sail-next-tailor-docs-publisher

import React from 'react';
import {Banner, Button, view} from '@sail/ui';

export const Dismiss = () => {
  const [open, setOpen] = React.useState(true);
  return (
    <view.div
      css={{
        stack: 'y',
        gap: 'large',
      }}
    >
      <Button onPress={() => setOpen(!open)}>
        {open ? 'Hide' : 'Show'} Banner
      </Button>
      {open && (
        <Banner
          type="default"
          onDismiss={() => setOpen(false)}
          title="Neutral title"
          description="A short description"
          actions={
            <Button onPress={() => console.log('hello world')}>Button</Button>
          }
        />
      )}
    </view.div>
  );
};
